import type React from 'react';

function BrinkCommerceIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 715.17 715.17" {...props}>
      <title>Brink Commerce Icon</title>

      <g id="Lager_1" data-name="Lager 1">
        <g id="Lager_2" data-name="Lager 2">
          <g id="Lager_1-2" data-name="Lager 1-2">
            <g id="S0J2Oa.tif">
              <path
                d="M212.59,230.92c95.66-55.72,189.58-55.36,283.97,1.02l-62.89,96.34c-65.76-42.6-144.61-22.49-183.69,20.24-44.14,48.25-48.43,119.68-14.23,171.74,35.78,54.45,104.07,77.5,165.53,55.86,57.46-20.01,97.81-80.04,93.3-141.09h-57.56c38.61-59.3,76.36-117.24,114.77-176.24l114.4,175.61h-56.46c-.6,10.68-.93,20.75-1.78,30.79-4.96,58.48-27.77,109.14-67.61,152.14-30.41,32.82-66.83,56.86-109.78,69.33-93.73,27.18-178.13,8.78-250.77-56.57-45.15-40.6-71.37-92.38-79.38-152.53-2.74-20.67-2.08-41.88-2.18-62.79-.14-37.52,.29-75.04,.56-112.54,.38-54.47,.81-108.93,1.27-163.38,.32-38.55,.67-77.1,1.05-115.68v-6.77h111.48V230.92Z"
                fill="currentColor"
              />
            </g>
          </g>
        </g>
        <rect width="715.17" height="715.17" fill="none" />
      </g>
    </svg>
  );
}

export default BrinkCommerceIcon;
